module.exports = __webpack_public_path__ + "img/2.9f6cffb4.jpg";